<template>
	<div id="app">
		<!-- 顶部导航 -->
		<Header />
		<!-- 路由出口 -->
		<router-view />
		<!-- 底部 -->
		<Footer />
	</div>
</template>

<script>
	
	import Header from '@/components/Layout/Header'
	
	import Footer from '@/components/Layout/Footer'

	export default {
		name: 'App',
		components: {
			Header,
			Footer
		}
	}
</script>

<style lang="scss">
	* {
		margin: 0;
		padding: 0;
		box-sizing: border-box;
	}

	body {
		font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
	}

	#app {
		width: 100%;
	}
</style>